class Pedagio {
  constructor() {
    this.id = null;
    this.idCliente = null;
    this.nome = null;
    this.dataVigenciaInicial = null;
    this.dataVigenciaFinal = null;
  }
}
export default Pedagio;